import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  :root {
    --primary: ${props => props.theme.colors.primary};
    --primary-hover: ${props => props.theme.colors.primaryHover};
    --secondary: ${props => props.theme.colors.secondary};
    --secondary-hover: ${props => props.theme.colors.secondaryHover};
    --background: ${props => props.theme.colors.background};
    --surface: ${props => props.theme.colors.surface};
    --text-main: ${props => props.theme.colors.text};
    --text-secondary: ${props => props.theme.colors.textSecondary};
    --border: ${props => props.theme.colors.border};
    
    --shadow-sm: 0 2px 10px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 5px 15px rgba(0, 0, 0, 0.08);
    --radius-md: 12px;
    --radius-full: 9999px;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Inter', sans-serif;
  }

  body {
    background-color: var(--background);
    color: var(--text-main);
  }
`;